import type { WorkOrderStatusEnum } from '@ztechapps/common.contract'
import includes from 'lodash/includes'
import { LOCKED_WORK_ORDER_STATUSES } from './lockedWorkOrderStatuses'

/**
 * A locked work order takes no more edits — Complete, Cancelled or Destructed. Backs the
 * production page's `canEditWorkOrder` (`productions/item/Context.tsx`).
 *
 * Precedent: `libs/logistic/common/src/utils/isLogisticEditLocked.ts:21`.
 */
export const isWorkOrderLocked = (status?: WorkOrderStatusEnum): boolean => includes(LOCKED_WORK_ORDER_STATUSES, status)
